import styled from 'styled-components';

import { COLORS, MOBILE, SPACE } from '@/nova/theme/tokens';

/* The marketing composers' header pills (Stats, a landing page's Links), next to the version picker. Shared by every
   asset composer so the pill reads the same on each. */

/** The studio's own Stats glyph (the side-menu bar-chart icon), tinted to the button's text colour via a CSS
 *  mask (same technique as the nav's MaskIcon) so it matches "Stats" everywhere else in the studio. */
export const StatsGlyph = styled.span`
  display: inline-block;
  width: 15px;
  height: 15px;
  flex: 0 0 auto;
  background-color: currentColor;
  -webkit-mask: url('https://micros-t.b-cdn.net/studio-menu-icon-pulse-1779968968265.svg') center / contain no-repeat;
  mask: url('https://micros-t.b-cdn.net/studio-menu-icon-pulse-1779968968265.svg') center / contain no-repeat;
`;

/** A header pill button (Stats, Links), next to the version picker. Its 6px gap and 6px / 10px padding are off the
 *  SPACE scale on purpose: the pill's established size, matched to the compact version select beside it. */
export const HeaderPill = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  border-radius: 999px;
  border: 1px solid ${COLORS.panelBorder};
  cursor: pointer;
  background: ${COLORS.surfaceInset};
  color: ${COLORS.textMuted};
  font-size: 13px;
  font-weight: 600;
  flex: 0 0 auto;

  &:hover {
    color: ${COLORS.text};
    border-color: ${COLORS.hoverBorderLit};
  }

  /* A phone's header has no room for labels: the glyph alone, in a round button (its name stays in aria-label). */
  ${MOBILE} {
    justify-content: center;
    width: ${SPACE[40]};
    height: ${SPACE[40]};
    padding: ${SPACE[0]};

    & > :not(:first-child) {
      display: none;
    }
  }
`;
